export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'extras': { id: 'extras', page: 'toutHorizontal', getter: () => import(/* webpackChunkName: 'extras' */ 'components/bolt/toutHorizontal/toutHorizontal') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'extras', getter: () => import(/* webpackChunkName: "extras" */ 'components/bolt/toutHorizontal/toutHorizontal'), component: 'toutHorizontal' },
	{ id: 'faq', getter: () => import(/* webpackChunkName: "faq" */ 'components/bolt/expandableTextList/expandableTextList'), component: 'expandableTextList' },
	{ id: 'signUp', getter: () => import(/* webpackChunkName: "signUp" */ 'components/bolt/text/text'), component: 'text' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
